import Vue from "vue";

Vue.mixin({
    methods: {
        arrayUnique(array) {
            return [...new Set(array)]
        }
    }
});
